<template>
	<div v-loading="fullscreenLoading">
		<div class="item-block">
			<div class="goods-list">
				<table>
					<tr>
						<td colspan="5">
							<i class="store-icon iconfont iconmendian"></i>
							方案模版
							
							<el-button style="float: right;" type="primary" class="el-button--primary" @click="solutCreate">立即生成</el-button>
						</td>
					</tr>
				</table>
			</div>
		</div>
		<!--方案模版-->
		<div class="item-block">
			<div clsas="address-list">
				<div class="address-item" v-for="(item, key) in cargoList" :key="item.id" :class="addressId == item.id ? 'active' : ''" >
					<div class="address-info" @click="setMemberAddress(item.id)">
						<div class="address-name">{{ item.name }}</div>
						<div class="address-mobile">
							<img class="goods-img" :src="$img(item.img, { size: 'mid' })" width="243" height="137" />							
						</div>
					</div>
				</div>
			
				<div class="clear"></div>
				<div class="pager" style="margin: 20px auto 10px;">
				  <el-pagination
						background 
						:pager-count="5" 
						:total="total" 
						prev-text="上一页" 
						next-text="下一页" 
						:current-page.sync="currentPage" 
						:page-size.sync="pageSize" 
						@size-change="handlePageSizeChange" 
						@current-change="handleCurrentPageChange" 
						hide-on-single-page
					></el-pagination> 
				</div>
			</div>
		</div>

		
		<!--商品信息-->
		<div class="item-block">
			<div class="goods-list">
				<table>
					<tr>
						<td width="73%">商品</td>
						<td width="16.5%">价格</td>
						<td width="10.5%">库存</td>
					</tr>
				</table>
			</div>
		</div>

		<div v-for="(siteItem, siteIndex) in orderPaymentData.shop_goods_list" :key="siteIndex">
			<div class="item-block">
				<div class="goods-list">
					<table>
						<tr v-for="(goodsItem, goodsIndex) in siteItem.goods_list" :key="goodsIndex">
							<td width="73%">
								<div class="goods-info">
									<div class="goods-info-left">
										<router-link :to="{ path: '/sku-' + goodsItem.sku_id }" target="_blank">
											<img class="goods-img" :src="$img(goodsItem.sku_image, { size: 'mid' })" @error="imageError(goodsIndex)" />
										</router-link>
									</div>
									<div class="goods-info-right">
										<router-link :to="{ path: '/sku-' + goodsItem.sku_id }" target="_blank">
											<div class="goods-name">{{ goodsItem.sku_name }}</div>
										</router-link>
									</div>
								</div>
							</td>
							<td width="16.5%" class="goods-price">￥{{ goodsItem.discount_price }}</td>
							<td width="10.5%" class="goods-num">{{ goodsItem.stock }}</td>
							
						</tr>
					</table>

					<!--配送方式、留言、优惠券、店铺优惠-->
				</div>
			</div>
		</div>


		<!--结算-->
		<div class="item-block">
			<div class="order-submit">
				<div class="order-money">
				</div>
				<el-button type="primary" class="el-button--primary" @click="solutCreate">立即生成</el-button>
			</div>
			<div class="clear"></div>
		</div>

	</div>
</template>

<script>
	import PicZoom from 'vue-piczoom';
	import detail from './solut.js';
	export default {
		name: 'payment',
		components: {
			PicZoom
		},
		mixins: [detail]
	};
</script>

<style lang="scss" scoped>
	@import './solut.scss';
</style>
